<template>
  <div class="boixnn">
    <div class="textname">
      <img width="670px" height="80px" src="../image/aibiao.png" alt="" />
    </div>
    <!-- {{ currentIndex }} -->
    <div class="swiper-container">
      <!-- 内容 -->
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, index) in list" :key="index">
          <div class="boxcarder" :class="{ selected: currentIndex == index }" @click="cilckimg(index)">
            <div>
              <!-- 图片 -->
              <img width="366px" height="189px" :src="item.img" alt="" />
            </div>
            <div class="textswiper">
              <div>
                <div class="titleitem">{{ item.title }}</div>
                <div class="testnow">{{ item.text }}</div>
              </div>

              <div class="namenow" :class="{ activeboutton: currentIndex == index }" @click="scrollToAnchor(index)">
                立即体验
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div> -->

      <!-- <div class="swiper-pagination"></div> -->
    </div>
    <div class="boutton">
      <img class="imgone" width="47px" @click="leftboutton" src="../image/left.png" alt="" />
      <img width="47px" @click="rightboutton" src="../image/right.png" alt="" />
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/css/swiper.css'

export default {
  data() {
    return {
      swiper: null,
      list: [
        {
          img: require('../image/baximglun.png'),
          title: '茶饮',
          text: ' 通过监控系统结合AI能力，对企业的检查标准进行远程巡检，跟进整改进度。并进行考核打分，实现低成本的高效管理。',
        },
        {
          img: require('../image/icone/catering.png'),
          title: '餐饮',
          text: ' 通过融合客流分析、图像识别和语音识别三大技术，我们的数字引流产品将帮助您更好的理解顾客行为，优化营销策略，提升商业效益。',
        },
        {
          img: require('../image/shagncang.png'),
          title: '商场',
          text: ' 通过AI对当前商品陈列视频画面的学习训练记忆陈列周期、热卖商品、沉默商品并适时提醒调整。',
        },
        {
          img: require('../image/icone/hotel.png'),
          title: '酒店',
          text: ' 设备安检，接入亿大师设备后所有设备数据入网，当设备出现故障时系统会自动预警并告知设备故障情况降低酒店巡检频次。',
        },
        {
          img: require('../image/icone/DepartmentStoreRetail.png'),
          title: '百货零售',
          text: ' 系统会实时监测销售人员对新品的销售介绍，同时记录新品的客户碰触，并且形成数据报表。',
        },
      ],
      currentIndex: 2,
      swiperOptions: {
        slidesPerView: 5,
        spaceBetween: 20,

        slideToClickedSlide: true,
        centeredSlides: true,
        // loop: true,
        initialSlide: 2,

        breakpoints: {
          250: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          615: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          980: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 50,
          },
          1389: {
            slidesPerView: 4,
            spaceBetween: 50,
          },
        },
        // 自动轮播
        // autoplay: {
        //   delay: 3000,
        //   disableOnInteraction: false,
        // },
        // 分页器
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        // 前进后退按钮
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        on: {
          slideChange: () => {
            if (this.swiper) {
              console.log('给i方法是否实现', this.swiper.realIndex)
              this.currentIndex = this.swiper.realIndex // 监听滑块切换，更新 currentIndex
            }
            if (this.currentIndex >= this.list.length) {
              this.currentIndex = 0
            } else if (this.currentIndex < 0) {
              this.currentIndex = this.list.length - 1
            }
          },
        },
      },
    }
  },
  // updated() {
  //   this.swiper = new Swiper('.swiper-container', this.swiperOptions)
  // },
  mounted() {
    this.swiper = new Swiper('.swiper-container', this.swiperOptions)
    console.log('初始的时候', this.swiper.realIndex)
  },
  methods: {
    scrollToAnchor(index) {
      if (index != this.currentIndex) {
        return
      }
      const targetElement = document.getElementById('about')
      targetElement.scrollIntoView({
        behavior: 'smooth', // 平滑滚动
        block: 'start', // 滚动到目标元素顶部
      })
    },
    cilckimg(index) {
      console.log('输出index', index)
      this.currentIndex = index
      if (this.currentIndex >= this.list.length) {
        this.currentIndex = 0
      } else if (this.currentIndex < 0) {
        this.currentIndex = this.list.length - 1
      }
      this.swiper.slideTo(this.currentIndex)
      this.$forceUpdate()
    },
    leftboutton() {
      if (this.swiper) {
        this.swiper.slidePrev()
        // this.currentIndex == 0 ? '' : (this.currentIndex -= 1)
        // if (this.swiper.realIndex != 0) {
        if (this.swiper.realIndex >= this.list.length) {
          this.currentIndex = 0
        } else if (this.swiper.realIndex < 0) {
          this.currentIndex = this.list.length - 1
        }
        this.swiper.slideTo(this.swiper.realIndex)
        // }
      }
      this.$forceUpdate()
    },
    rightboutton() {
      if (this.swiper) {
        this.swiper.slideNext()
        // this.currentIndex == 4 ? '' : ++this.currentIndex
        // console.log('输出list', this.list)
        this.swiper.slideTo(this.swiper.realIndex)
      }
      this.$forceUpdate()
    },
  },
}
</script>
<style lang="less" scoped>
.boixnn {
  height: 890px;
  padding-top: 138px;
  .textname {
    width: 670px;
    margin: 0 auto;
    margin-bottom: 48px;
  }
  .boutton {
    width: 165px;
    text-align: center;
    margin: 0 auto;
    margin-top: 48px;
    .imgone {
      margin-right: 40px;
    }
  }
}
.swiper-container {
  width: 100%;
  /* height: 890px; */
}
.swiper-slide {
  /* line-height: 100px; */
  padding-bottom: 10px;
}
.boxcarder {
  width: 367px;
  height: 440px;
  background: #ffffff;
  border-radius: 18px 18px 18px 18px;
  border: 1px solid rgba(204, 204, 204, 0.3);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .textswiper {
    flex: 1;
    display: flex;
    padding: 24px 78px 25px 26px;
    flex-direction: column;
    justify-content: space-between;
    .namenow {
      width: 165px;
      height: 46px;
      text-align: center;
      line-height: 46px;
      border-radius: 34px 34px 34px 34px;
      border: 1px solid #e1e1e1;
    }
    .titleitem {
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 22px;
    }
    .testnow {
      margin-top: 10px;
      line-height: 22px;
      font-weight: 500;
      font-size: 14px;
      color: rgba(51, 51, 51, 0.8);
    }
  }
  img {
    border-radius: 18px 18px 18px 18px;
  }
}
.selected {
  background: #ffffff;
  box-shadow: 0px 10px 20px 0px rgba(116, 126, 122, 0.2);
  border-radius: 18px 18px 18px 18px;
  border: 1px solid rgba(204, 204, 204, 0.5);
}
.activeboutton {
  color: #ffffff;
  background: #57cc9e;
  border-radius: 34px 34px 34px 34px;
}
</style>